import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const CheckIconGreen: React.FC<NormalIconProps> = (props) => (
	<svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="solar:check-circle-linear">
			<g id="Group">
				<path
					id="Vector"
					d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
					stroke="#065624"
					strokeWidth="1.5"
				/>
				<path
					id="Vector_2"
					d="M8.5 12.5L10.5 14.5L15.5 9.5"
					stroke="#065624"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</g>
	</svg>
);
